import { createFileRoute } from "@tanstack/react-router";
import { DocumentsPage } from "@/components/documents/documents-page";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/documents/")({
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { projectSlug } = Route.useParams();
  // Keyed by project: the active row is one project's.
  return <DocumentsPage key={projectSlug} />;
}
